<template>
    <div></div>
</template>

<script>
export default {
    data() {
        return {
            totalAssets: 0,
            loaded: 0,
        };
    },
    mounted() {
        const PNG_ASSETS = require
            .context('@/assets/', true, /^.*\.png$/)
            .keys();
        const JPG_ASSETS = require
            .context('@/assets/', true, /^.*\.jpg$/)
            .keys();
        const GIF_ASSETS = require
            .context('@/assets/', true, /^.*\.gif$/)
            .keys();
        PNG_ASSETS.forEach((path) => {
            this.loadImage(path);
        });
        JPG_ASSETS.forEach((path) => {
            this.loadImage(path);
        });
        GIF_ASSETS.forEach((path) => {
            this.loadImage(path);
        });
        this.totalAssets = PNG_ASSETS.length + JPG_ASSETS.length + GIF_ASSETS.length;
    },
    methods: {
        loadImage(path) {
            const PATH = path.replace(/.\//, 'assets/');
            const IMG = new Image();
            IMG.onload = () => {
                this.loaded += 1;
                if (this.totalAssets === this.loaded) this.$emit('loaded');
            };
            // eslint-disable-next-line
            IMG.src = require(`@/${PATH}`);
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
